/** @file       MobileNavHeader.css
 *  @author     Kirill Kirnichansky <kirill@kingsds.network>
 *              
 *  @date       June 2022
 *
 *              stylesheet for MobileNavHeader component
 */
 
.navbar {
  background-color: #f1f1f1;
  padding: 1em 0;
  box-shadow: 2px 1px 5px darkgray;
  display: none;
}

.navbar .mobile-menu-tab {
  font-size: 1.6rem;
  display: inline-block;
  vertical-align: middle;
  color: gray;
  padding: 0 0.5em 0 0.7em;
  background-color: transparent;
  border: none;
  cursor: pointer;
}

.mobile-menu-tab:hover {
  color: #1e1e1e;
  transition: 150ms;
}

.title {
  width: fit-content;
  display: inline-block;
  vertical-align: middle;
  margin: 0;
  color: var(--primary-hue-main);
  font-size: 1.75em;
}

@media only screen and (max-width: 1000px) {
  .navbar {
    display: block;
  }
}

.mobile-menu-icon {
  filter: brightness(0) saturate(100%) invert(58%) sepia(6%) saturate(9%) hue-rotate(331deg) brightness(94%) contrast(85%);
  width: 30px;
  transition: filter linear 0.1s;
}

.mobile-menu-icon:hover {
  filter: brightness(0) saturate(100%);
}
